.container {
    width: 100%;
    /* The SVG has a lot of mostly empty space at the top due to the large dropshadow gradient
    this moves the image up a bit to have less visual empty space wothout changing the svg */
    margin-top: -50px;
}
